<template>
  <form
    @submit.prevent="formValidate"
    novalidate
    autocomplete="off"
    class="form form-forgot-password"
  >
    <transition name="fade">
      <div
        v-if="errorMessage"
        class="form-row"
      >
        <div class="form-error q-py-sm text-negative">
          {{ errorMessage }}
        </div>
      </div>
    </transition>

    <q-input
      v-model="form.email"
      v-validate="getVValidate('required|email')"
      :error="errors.has('email')"
      class="form-row"
      filled
      stack-label
      no-error-icon
      color="black"
      name="email"
      label="Email"
      type="email"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in emailErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>

    <div class="form-actions">
      <div class="form-row">
        <q-btn
          :loading="isProcessing"
          :label="$t('buttons.send_reset_email') | uppercase"
          rounded
          color="primary"
          text-color="white"
          class="full-width"
          type="submit"
        />
      </div>
      <div class="form-row">
        <router-link :to="{ name: 'login' }">
          {{ $t('Back to Login') }}
        </router-link>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import FormBase from './FormBase';

@Component({
  name: 'form-forgot-password',
  extends: FormBase,
})
export default class FormForgotPassword extends Vue {
  form = {
    email: '',
  };

  get emailErrors() {
    return this.getErrorMessages('email', 'Email');
  }
}
</script>
